import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND}/api`;
export const http = axios.create({ baseURL: API, timeout: 10000 });

export const WHATSAPP_URL = `https://wa.me/918423746910?text=${encodeURIComponent(
  "Hi, I have a question about the Wealth Code Summit"
)}`;

export const formatPrice = (n) =>
  typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : "₹[TBA]";

export const EVENT_START = new Date("2026-11-15T09:00:00+05:30").getTime();

export function computePricing(s, now) {
  return { tier: s?.tier1 || {}, eventStart: EVENT_START, started: now >= EVENT_START };
}

const PASS_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "src"];

export function checkoutUrl(raw) {
  if (!raw || !/^https?:\/\//i.test(raw)) return null;
  try {
    const url = new URL(raw);
    const page = new URLSearchParams(window.location.search);
    PASS_KEYS.forEach((k) => {
      const v = page.get(k);
      if (v) url.searchParams.set(k, v);
    });
    return url.toString();
  } catch {
    return null;
  }
}

export function youtubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/|live\/)([A-Za-z0-9_-]{11})/);
  if (m) return m[1];
  return /^[A-Za-z0-9_-]{11}$/.test(url.trim()) ? url.trim() : null;
}

export const imgSrc = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

export function deadlineLabel(ms) {
  if (!ms) return "";
  return new Date(ms).toLocaleDateString("en-IN", { day: "numeric", month: "long", timeZone: "Asia/Kolkata" });
}

export function isoToIstInput(iso) {
  const t = new Date(iso).getTime();
  if (!t) return "";
  return new Date(t + 330 * 60000).toISOString().slice(0, 16);
}

export const istInputToIso = (v) => (v ? `${v}:00+05:30` : "");
